import { render, staticRenderFns } from "./EditOrderItemLocation.vue?vue&type=template&id=1353c802&scoped=true"
import script from "./EditOrderItemLocation.vue?vue&type=script&lang=js"
export * from "./EditOrderItemLocation.vue?vue&type=script&lang=js"
import style0 from "./EditOrderItemLocation.vue?vue&type=style&index=0&id=1353c802&prod&lang=scss&scoped=true"
import style1 from "./EditOrderItemLocation.vue?vue&type=style&index=1&id=1353c802&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1353c802",
  null
  
)

export default component.exports